import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

/** Hard cap the API puts on the assignment note: over it the POST answers 422. */
export const ASSIGN_NOTE_MAX_LENGTH = 1024;

export default class PermissionsService {
    /**
     * Assigns a cue-sheet item to a user.
     * @param {Array} queryParams - [key, value] pairs: userId, cueSheetId and
     *   an optional `note` (max ASSIGN_NOTE_MAX_LENGTH chars) that reaches the
     *   assignee as the text of the CUE_ASSIGNED notification. Sent as a query
     *   param, not in the body, as the API expects.
     */
    static async permissionsAssign(queryParams) {
        return await NetworkService.postAsync(`${API_BASE_URL}/permissions/assign`, {}, queryParams);
    }

    static async permissionsUnAssign(queryParams) {
        return await NetworkService.postAsync(`${API_BASE_URL}/permissions/unassign`, {}, queryParams);
    }
}
